export default __webpack_public_path__ + "static/media/Platnum_Badge.a5d7abd1.svg";